import React from 'react';
import { st, classes } from './SkeletonCircle.st.css';
import { DEFAULT_DIAMETER } from './SkeletonCircle.constants';
import { DEFAULT_SKIN } from '../SkeletonGroup/SkeletonGroup.constants';
import Box from '../Box';
import { SkeletonGroupContext } from '../SkeletonGroup';
import { SkeletonCircleProps } from './SkeletonCircle.types';

/** SkeletonCircle */
function SkeletonCircle({
  dataHook,
  className,
  diameter = DEFAULT_DIAMETER,
  margin,
  marginLeft,
  marginRight,
  marginTop,
  marginBottom,
}: SkeletonCircleProps) {
  return (
    <SkeletonGroupContext.Consumer>
      {context => {
        const skin = context?.skin || DEFAULT_SKIN;
        return (
          <div
            data-hook={dataHook}
            className={className}
            data-diameter={diameter}
            data-skin={skin}
          >
            <Box
              width={diameter}
              height={diameter}
              margin={margin}
              marginLeft={marginLeft}
              marginRight={marginRight}
              marginTop={marginTop}
              marginBottom={marginBottom}
              className={st(classes.root, { skin })}
            />
          </div>
        );
      }}
    </SkeletonGroupContext.Consumer>
  );
}

SkeletonCircle.displayName = 'SkeletonCircle';

export default SkeletonCircle;
